import React, { Component } from "react";
import { Marker, InfoWindow } from "react-google-maps";

class CustomMarker extends Component {
    state = {
        showInfoWindow: false,
    };
    handleMouseOver = (e) => {
        this.setState({
            showInfoWindow: true,
        });
    };
    handleMouseExit = (e) => {
        this.setState({
            showInfoWindow: false,
        });
    };
    render() {
        const { showInfoWindow } = this.state;
        const { info, user } = this.props;
        return (
            <Marker
                position={this.props.position}
                icon={this.props.icon}
                onClick={this.props.onClick}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseExit}
            >
                {user.distance && (
                    <InfoWindow>
                        <div>
                            <p>Distância de {user.distance} metros </p>
                        </div>
                    </InfoWindow>
                )}
                {showInfoWindow && (
                    <InfoWindow>
                        <div>
                            <h5>{user.user_type}</h5>
                            <small>
                                <strong>Endereço: </strong>
                                {user.street} <br />
                                <strong>Bairro: </strong>
                                {user.neighborhood}
                            </small>
                        </div>
                    </InfoWindow>
                )}
            </Marker>
        );
    }
}
export default CustomMarker;
